<template>
  <div class="full">
    <slot class="full" v-if="canView === 'ok'"></slot>

    <div class="full" v-else-if="canView === 'loading'">
      <ChatBoxTitle>
        <div slot="left">
          <img src="../img/list.svg" class="hide-desktop" @click="$emit('openMenu', true)" alt="back">
        </div>
        <div slot="center">
          Loading...
        </div>
        <div slot="right">
        </div>
      </ChatBoxTitle>
      <div class="marginer">
        <h1 >
          Loading...
        </h1>
      </div>
    </div>
    <div class="full" v-else-if="canView === 'error'">
      <ChatBoxTitle>
        <div slot="left">
          <img src="../img/list.svg" class="hide-desktop" @click="$emit('openMenu', true)" alt="back">
        </div>
        <div slot="center">
          Error...
        </div>
        <div slot="right">
        </div>
      </ChatBoxTitle>
      <h2 class="marginer" v-if="err && err.message">
        <div v-if="err.code === 404">
          Room not found.
        </div>
      </h2>
    </div>
    <div class="full " v-else-if="canView === 'password'">
      <ChatBoxTitle>
        <div slot="left">
          <img src="../img/list.svg" class="hide-desktop" @click="$emit('openMenu', true)" alt="back">
        </div>
        <div slot="center">
          Enter Password
        </div>
        <div slot="right">
        </div>
      </ChatBoxTitle>
      <div class="marginer">
        <h2 v-if="info" class="center-title">
          Room: {{ info.title }}
        </h2>
        <p>
          <input class="yo" type="password" v-model="password" @keydown.enter="checkRoomPW({ roomID: roomID, pw: password })" />
          <button class="yo-btn" @click="checkRoomPW({ roomID: roomID, pw: password })">Enter</button>
        </p>
        <p v-if="err" class="warn">
          Bad Password
        </p>
      </div>

    </div>
  </div>
</template>

<script>
import ChatBoxTitle from './ChatBoxTitle.vue'

import { API } from '@/yoteach2-gui/parts/index.js'

export default {
  components: {
    ChatBoxTitle
  },
  props: {
    roomID: {}
  },
  data () {
    return {
      err: false,
      info: false,
      password: '',
      canView: 'loading'
    }
  },
  mounted () {
    this.getRoomInfo()
  },
  methods: {
    getRoomInfo () {
      API.getRoom({ _id: this.roomID })
        .then((resp) => {
          console.log(resp.data)
          let info = resp.data
          this.info = info
          if (info.enableRoomEntryPassword) {
            this.canView = 'password'
          } else if (!info.enableRoomEntryPassword) {
            this.canView = 'ok'
          }
          this.$forceUpdate()
        })
        .catch(err => {
          this.err = err.response.data
          this.canView = 'error'
          console.error(err)
        })
    },
    checkRoomPW ({ roomID, pw }) {
      this.err = false
      API.checkRoomEntryPW({ _id: roomID, roomEntryPassword: pw })
        .then(() => {
          this.canView = 'ok'
          this.$forceUpdate()
        }, (err) => {
          this.err = err
          this.canView = 'password'
          this.$forceUpdate()
        })
    }
  }
}
</script>

<style scoped>
.full{
  height: 100%;
  width: 100%;
}
.center-title{
  text-align: center;
}
.yo-btn:hover,
.yo-btn{
  background-image: none;
  box-shadow: none;
  text-shadow: none;
  background-color: white;
  background-image: none;
}

.marginer{
  margin: 30px;
}

.warn{
  color: red;
}
@media screen and (min-width: 767px) {
  .hide-desktop{
    display: none;
  }
}
</style>
